import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "d-none d-md-flex mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-0" }, "Manage Conflict", -1)
const _hoisted_4 = { class: "form" }
const _hoisted_5 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12 col-md-3 mb-4 mb-md-0" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "col d-md-none" }
const _hoisted_13 = { class: "d-flex d-md-none ms-4 justify-content-center align-items-center" }
const _hoisted_14 = { class: "form-check form-switch form-check-custom form-check-solid m-auto" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "allDaySwitchMobile"
}, " All/Multiple Days ", -1)
const _hoisted_16 = {
  key: 0,
  class: "col-6 col-md-3 mb-4 mb-md-0"
}
const _hoisted_17 = {
  key: 1,
  class: "col-6 col-md-3 mb-4 mb-md-0"
}
const _hoisted_18 = {
  key: 2,
  class: "col-6 col-md-3 mb-4 mb-md-0"
}
const _hoisted_19 = { class: "col-12 col-md-3 mb-4 mb-md-0" }
const _hoisted_20 = { class: "d-none d-md-flex ms-4 justify-content-center align-items-center" }
const _hoisted_21 = { class: "form-check form-switch form-check-custom form-check-solid m-auto" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "allDaySwitch"
}, " All/Multiple Days ", -1)
const _hoisted_23 = { class: "d-flex flex-wrap" }
const _hoisted_24 = { class: "form-check form-switch form-check-custom form-check-solid m-auto" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "isPrivateSwitch"
}, " Hide conflict's name from stage managers ", -1)
const _hoisted_26 = { class: "form-check form-switch form-check-custom form-check-solid m-auto mt-4 mt-md-0" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "isFlexibleSwitch"
}, " Conflict is flexible ", -1)
const _hoisted_28 = { class: "d-flex justify-content-center mt-8" }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mb-0" }, "Conflict(s) found"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, "this calls will conflict with this new entry")
], -1)
const _hoisted_31 = { class: "fs-4" }
const _hoisted_32 = { class: "fs-6" }
const _hoisted_33 = { class: "d-flex justify-content-center mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputGroup = _resolveComponent("InputGroup")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_time_select = _resolveComponent("el-time-select")!
  const _component_ModalBase = _resolveComponent("ModalBase")!

  return (_openBlock(), _createBlock(_component_ModalBase, {
    ref: "modal",
    size: "modal-lg",
    title: _ctx.title,
    "has-header": false,
    "has-toolbar": true
  }, {
    "header-button": _withCtx(() => [
      (_ctx.mode === 'update')
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args))),
            class: "btn btn-link btn-color-danger btn-active-color-primary p-0 ms-auto"
          }, "Delete"))
        : _createCommentVNode("", true)
    ]),
    body: _withCtx(() => [
      (!_ctx.displayCollisions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              (_ctx.mode !== 'add')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    class: "btn-sm ms-auto",
                    onClick: _ctx.remove,
                    type: "danger"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Delete ")
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_InputGroup, {
                "is-required": true,
                label: "Name",
                "is-loading": _ctx.isFetching
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["form-control", {'is-invalid': _ctx.v$.entity.name.$error}]),
                    placeholder: "e.g. Doctor Appointment",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.entity.name) = $event))
                  }, null, 2), [
                    [_vModelText, _ctx.entity.name]
                  ]),
                  (_ctx.v$.entity.name.$error)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Please give your conflict a name."))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["is-loading"]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_InputGroup, {
                    "is-required": true,
                    "is-loading": _ctx.isFetching,
                    label: "When",
                    class: "m-1"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(_component_el_date_picker, {
                                class: _normalizeClass({'is-invalid': _ctx.v$.entity.start.$error}),
                                type: "date",
                                placeholder: "Start date",
                                format: "MM/DD/YYYY",
                                clearable: false,
                                modelValue: _ctx.startDate,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.startDate) = $event))
                              }, null, 8, ["class", "modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    value: "",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.allDay) = $event)),
                                    id: "allDaySwitchMobile"
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.allDay]
                                  ]),
                                  _hoisted_15
                                ])
                              ])
                            ])
                          ])
                        ]),
                        (!_ctx.entity.allDay)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              (!_ctx.entity.allDay)
                                ? (_openBlock(), _createBlock(_component_el_time_select, {
                                    key: 0,
                                    start: "00:00",
                                    step: "00:15",
                                    end: "23:59",
                                    placeholder: "Start time",
                                    format: "h:mm A",
                                    modelValue: _ctx.startTime,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.startTime) = $event)),
                                    clearable: false,
                                    class: _normalizeClass(["", {'is-invalid': _ctx.v$.entity.start.$error}]),
                                    autocomplete: "false"
                                  }, null, 8, ["modelValue", "class"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (!_ctx.entity.allDay)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createVNode(_component_el_time_select, {
                                start: "00:00",
                                step: "00:15",
                                end: "23:59",
                                placeholder: "End time",
                                modelValue: _ctx.endTime,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.endTime) = $event)),
                                clearable: false,
                                format: "h:mm A",
                                class: _normalizeClass(["", {'is-invalid': _ctx.v$.entity.end.$error}]),
                                autocomplete: "false"
                              }, null, 8, ["modelValue", "class"])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              _createVNode(_component_el_date_picker, {
                                class: _normalizeClass([{'is-invalid': _ctx.v$.entity.end.$error}, ""]),
                                type: "date",
                                placeholder: "End date",
                                format: "MM/DD/YYYY",
                                clearable: false,
                                modelValue: _ctx.endDate,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.endDate) = $event))
                              }, null, 8, ["class", "modelValue"])
                            ])),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                value: "",
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.allDay) = $event)),
                                id: "allDaySwitch"
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.allDay]
                              ]),
                              _hoisted_22
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["is-loading"])
                ])
              ]),
              _createVNode(_component_InputGroup, {
                "is-required": false,
                label: "Comments",
                "is-loading": _ctx.isFetching
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control",
                    placeholder: "Enter comments for stage managers to view regarding this conflict.",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.entity.comment) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.entity.comment]
                  ])
                ]),
                _: 1
              }, 8, ["is-loading"]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    value: "",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.entity.isPrivate) = $event)),
                    id: "isPrivateSwitch"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.entity.isPrivate]
                  ]),
                  _hoisted_25
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    value: "",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.entity.isFlexible) = $event)),
                    id: "isFlexibleSwitch"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.entity.isFlexible]
                  ]),
                  _hoisted_27
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_Button, {
                onClick: _ctx.toggleClosed,
                type: "secondary",
                class: "d-md-none"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cancel")
                ]),
                _: 1
              }, 8, ["onClick"]),
              (_ctx.mode === 'add')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.commit(true, false))),
                    class: "ms-4 ms-md-0",
                    "is-loading": _ctx.isLoading
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Add Conflict ")
                    ]),
                    _: 1
                  }, 8, ["is-loading"]))
                : _createCommentVNode("", true),
              (_ctx.mode === 'update')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.commit(false, false))),
                    class: "ms-4 ms-md-0",
                    "is-loading": _ctx.isLoading
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Save Changes ")
                    ]),
                    _: 1
                  }, 8, ["is-loading"]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.displayCollisions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collisions, (collision) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "d-flex flex-column",
                  key: collision.entityId
                }, [
                  _createElementVNode("div", _hoisted_31, _toDisplayString(collision.title), 1),
                  _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.getFriendlyDateTime(collision.start)) + " - " + _toDisplayString(_ctx.getFriendlyDateTime(collision.end)), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_Button, {
                onClick: _ctx.hideCollisions,
                type: "secondary",
                "is-loading": _ctx.isLoading,
                class: "me-4"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Go Back & Make Changes ")
                ]),
                _: 1
              }, 8, ["onClick", "is-loading"]),
              (_ctx.mode === 'add')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.commit(true, true))),
                    "is-loading": _ctx.isLoading
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Add Conflict Anyway ")
                    ]),
                    _: 1
                  }, 8, ["is-loading"]))
                : _createCommentVNode("", true),
              (_ctx.mode === 'update')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.commit(false, true))),
                    "is-loading": _ctx.isLoading
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Update Conflict Anyway ")
                    ]),
                    _: 1
                  }, 8, ["is-loading"]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title"]))
}